module.exports = __webpack_public_path__ + "img/cover-promotion-bg.cee1996b.jpg";